export default {
  state: {
    billingPayment: {}
  },

  getters: {
    getBillingPayment (state) {
      return state.billingPayment
    }
  },

  mutations: {
    setBillingPayment (state, billingPayment) {
      state.billingPayment = billingPayment
    }
  }
}
